import {
  LinearProgress,
  makeStyles,
  Dialog,
  DialogActions,
  DialogContent,
  Button,
  Typography,
  DialogTitle,
  DialogContentText,
  TextField,
  Snackbar,
} from "@material-ui/core";
import React, { useEffect, useRef, useState } from "react";
import Firebase from "../js/Firebase";
import "./layout.css";

const offerOptions = {
  offerToReceiveAudio: 1,
  offerToReceiveVideo: 1,
};

const serverConfiguration = {
  iceServers: [
    {
      urls: "stun:stun.l.google.com:19302",
    },
    {
      urls: "turn:numb.viagenie.ca",
      username: "abhi.kohokade@gmail.com",
      credential: "abhi.kohokade@gmail.com",
    },
  ],
  iceCandidatePoolSize: 10,
};

const useStyles = makeStyles((theme) => ({
  localVideo: {
    height: "100%",
    maxHeight: "100%",
    maxWidth: "100%",
    objectFit: "cover",
    width: "100%",
  },
  miniVideo: {
    border: "1px solid gray",
    bottom: "20px",
    left: "20px",
    maxHeight: "17%",
    maxWidth: "17%",
    opacity: 1,
    position: "absolute",
    transition: "opacity 1s",
    zIndex: 2,
  },
}));

const Home = (props) => {
  const classes = useStyles();
  const mode = props.match.params.init;
  const roomId = props.match.params.id;
  const callerRef = useRef(null);
  const calleeRef = useRef(null);
  const [succees, setSuccees] = useState(true);
  const [dialog, setDialog] = useState(false);
  function closeDialog() {
    setDialog(false);
  }
  const [url, setUrl] = useState("");
  const [msg, setMsg] = useState("");
  const [snack, setSnack] = useState(false);

  useEffect(() => {
    async function process() {
      const strm = await navigator.mediaDevices.getUserMedia({
        video: true,
        audio: true,
      });

      callerRef.current.srcObject = strm;
      const vs = strm.getVideoTracks();
      if (vs.length > 0) {
      }

      if (mode === "true") {
        setUrl("https://" + window.location.hostname + "/r/false/" + roomId);
        setDialog(true);

        const callerPc = new RTCPeerConnection(serverConfiguration);
        callerPc.onicecandidate = async (e) => {
          if (e.candidate) {
            await Firebase.firestore()
              .collection("book")
              .doc("" + roomId)
              .collection("callerCandidate")
              .add(e.candidate.toJSON());
          }
        };

        callerPc.oniceconnectionstatechange = (e) => {
          printState("callerPc", callerPc, e);
        };

        {
          // getting track and write it on connection
          strm.getTracks().forEach((track) => callerPc.addTrack(track, strm));
        }

        {
          //get track and show in video element
          callerPc.ontrack = function (e) {
            setSuccees(false);
            if (calleeRef.current.srcObject !== e.streams[0]) {
              calleeRef.current.srcObject = e.streams[0];
            }
          };
        }

        {
          // Creating and saving offer
          const offer = await callerPc.createOffer(offerOptions);
          callerPc.setLocalDescription(offer);
          let off = {
            offer: {
              type: offer.type,
              sdp: offer.sdp,
            },
          };
          await Firebase.firestore()
            .collection("book")
            .doc("" + roomId)
            .set(off);
        }

        {
          // Fetching ICE candidate and setting it
          console.log("Fetching ICE candidate and setting it");
          await Firebase.firestore()
            .collection("book")
            .doc("" + roomId)
            .collection("calleeCandidate")
            .onSnapshot(function (snapshot) {
              snapshot.forEach(function (doc) {
                // console.log(doc.data());
                callerPc.addIceCandidate(new RTCIceCandidate(doc.data()));
              });
            });
        }

        {
          // Fetching Answer and setting remote description
          console.log("Fetching ICE candidate and setting it");
          await Firebase.firestore()
            .collection("book")
            .doc("" + roomId)
            .collection("answer")
            .onSnapshot(function (snapshot) {
              snapshot.forEach(function (doc) {
                console.log(doc.data().answer);
                callerPc.setRemoteDescription(
                  new RTCSessionDescription(doc.data().answer)
                );
              });
            });
        }
      } else {
        const calleePc = new RTCPeerConnection(serverConfiguration);
        calleePc.onicecandidate = async (e) => {
          if (e.candidate) {
            await Firebase.firestore()
              .collection("book")
              .doc("" + roomId)
              .collection("calleeCandidate")
              .add(e.candidate.toJSON());
          }
        };

        calleePc.oniceconnectionstatechange = (e) => {
          printState("calleePc", calleePc, e);
        };

        {
          // getting track and write it on connection
          strm.getTracks().forEach((track) => calleePc.addTrack(track, strm));
        }

        {
          //get track and show in video element
          calleePc.ontrack = function (e) {
            setSuccees(false);
            if (calleeRef.current.srcObject !== e.streams[0]) {
              calleeRef.current.srcObject = e.streams[0];
            }
          };
        }

        {
          // Getting remote offer and set to callee
          const offer = await Firebase.firestore()
            .collection("book")
            .doc("" + roomId)
            .get();
          await calleePc.setRemoteDescription(offer.data().offer);
        }

        {
          // adding ice candidate to callee
          const callerCandidate = await Firebase.firestore()
            .collection("book")
            .doc("" + roomId)
            .collection("callerCandidate")
            .get();
          callerCandidate.forEach(async function (doc) {
            console.log(JSON.stringify(doc.data()));
            await calleePc.addIceCandidate(new RTCIceCandidate(doc.data()));
          });
        }

        {
          // Creating answer and setting in firebase
          const answer = await calleePc.createAnswer();
          let d = {
            answer: {
              type: answer.type,
              sdp: answer.sdp,
            },
          };
          console.log(d);
          await Firebase.firestore()
            .collection("book")
            .doc("" + roomId)
            .collection("answer")
            .add(d);

          try {
            await calleePc.setLocalDescription(answer);
          } catch (e) {
            console.log("E calleePc.setLocalDescription" + e.message);
          }
        }
      }
    }

    process();

    function printState(name, pc, event) {
      console.log(name + " ICE STATE " + pc.connectionState);
    }
  }, []);

  function closeSnack() {
    setSnack(false);
  }
  return (
    <div>
      <Snackbar
        anchorOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        open={snack}
        autoHideDuration={6000}
        onClose={closeSnack}
      ></Snackbar>
      {succees ? (
        <center>
          <LinearProgress /> <br />
          Waiting for remote connection
        </center>
      ) : (
        ""
      )}
      <div className="video-container">
        <video
          className="local-video"
          autoPlay
          playsInline
          ref={calleeRef}
        ></video>
      </div>
      <video
        autoPlay
        muted
        ref={callerRef}
        playsInline
        className={classes.miniVideo}
      ></video>

      <Dialog
        onClose={closeDialog}
        aria-labelledby="simple-dialog-title"
        open={dialog}
      >
        <DialogTitle id="simple-dialog-title">Remote Connection</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Copy and share following url to remote person
          </DialogContentText>
          <TextField
            autoFocus
            margin="dense"
            id="name"
            value={url}
            label="Sharable URL"
            type="email"
            fullWidth
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={closeDialog} color="primary">
            Done
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default Home;
